import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/learn", label: "Notes" },
    { to: "/videos", label: "Videos" },
    { to: "/search", label: "🔍 Search" },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setMenuOpen(false);
  };

  return (
    <nav style={s.nav}>
      <div style={s.inner}>
        <Link to="/" style={s.logo} onClick={() => setMenuOpen(false)}>
          <span style={{ fontSize: 22 }}>🎓</span>
          <span style={s.logoText}>LearnWithPayal</span>
        </Link>

        {/* Desktop */}
        <div className="desktop-nav" style={s.desktopLinks}>
          {links.map((l) => (
            <Link key={l.to} to={l.to} style={{ ...s.link, ...(pathname === l.to ? s.activeLink : {}) }}>
              {l.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/teacher" style={{ ...s.link, ...(pathname === "/teacher" ? s.activeLink : {}), color: "#fbbf24" }}>
                ⚙ Dashboard
              </Link>
              <div style={s.avatar}>{user.name[0].toUpperCase()}</div>
              <button style={s.logoutBtn} onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <Link to="/login" style={s.loginBtn}>Teacher Login</Link>
          )}
        </div>

        {/* Hamburger */}
        <button style={s.hamburger} onClick={() => setMenuOpen((p) => !p)} aria-label="Menu">
          <span style={{ fontSize: 20, color: "#94a3b8" }}>{menuOpen ? "✕" : "☰"}</span>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={s.mobileMenu}>
          {links.map((l) => (
            <Link key={l.to} to={l.to}
              style={{ ...s.mobileLink, ...(pathname === l.to ? s.mobileLinkActive : {}) }}
              onClick={() => setMenuOpen(false)}>
              {l.label}
            </Link>
          ))}
          <div style={s.mobileDivider} />
          {user ? (
            <>
              <Link to="/teacher" style={{ ...s.mobileLink, color: "#fbbf24" }} onClick={() => setMenuOpen(false)}>
                ⚙ Teacher Dashboard
              </Link>
              <div style={{ padding: "10px 24px", display: "flex", alignItems: "center", gap: 10 }}>
                <div style={s.avatar}>{user.name[0].toUpperCase()}</div>
                <span style={{ fontSize: 13, color: "#94a3b8", fontFamily: "'Sora',sans-serif" }}>{user.name}</span>
                <button style={{ ...s.logoutBtn, marginLeft: "auto" }} onClick={handleLogout}>Logout</button>
              </div>
            </>
          ) : (
            <Link to="/login" style={{ ...s.mobileLink, color: "#60a5fa" }} onClick={() => setMenuOpen(false)}>
              Teacher Login
            </Link>
          )}
        </div>
      )}
    </nav>
  );
}

const s = {
  nav: { position: "sticky", top: 0, zIndex: 100, background: "#0f172a", borderBottom: "1px solid #1e293b" },
  inner: { maxWidth: 1200, margin: "0 auto", padding: "0 20px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between" },
  logo: { display: "flex", alignItems: "center", gap: 8, textDecoration: "none" },
  logoText: { fontSize: 18, fontWeight: 700, color: "#fff", fontFamily: "'Sora',sans-serif" },
  desktopLinks: { display: "flex", alignItems: "center", gap: 4 },
  link: { color: "#94a3b8", textDecoration: "none", padding: "6px 12px", borderRadius: 8, fontSize: 13, fontWeight: 500, fontFamily: "'Sora',sans-serif" },
  activeLink: { color: "#fff", background: "rgba(255,255,255,0.08)" },
  avatar: { width: 30, height: 30, borderRadius: "50%", background: "#1d4ed8", color: "#fff", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Sora',sans-serif" },
  loginBtn: { background: "#3b82f6", color: "#fff", textDecoration: "none", borderRadius: 8, padding: "7px 14px", fontSize: 12, fontWeight: 600, fontFamily: "'Sora',sans-serif", marginLeft: 8 },
  logoutBtn: { background: "transparent", border: "1px solid #334155", color: "#94a3b8", borderRadius: 8, padding: "5px 12px", fontSize: 12, cursor: "pointer", fontFamily: "'Sora',sans-serif" },
  hamburger: { background: "none", border: "none", cursor: "pointer", padding: 6, display: "none" },
  mobileMenu: { background: "#0f172a", borderTop: "1px solid #1e293b", padding: "8px 0 16px" },
  mobileLink: { display: "block", color: "#cbd5e1", textDecoration: "none", padding: "12px 24px", fontSize: 15, fontFamily: "'Sora',sans-serif", fontWeight: 500 },
  mobileLinkActive: { color: "#fff", background: "rgba(255,255,255,0.05)" },
  mobileDivider: { height: 1, background: "#1e293b", margin: "8px 0" },
};
